module.exports = __webpack_public_path__ + "img/footer_logo.7045e130.png";